import script from "./AllSchedules.vue?vue&type=script&setup=true&lang=js"
export * from "./AllSchedules.vue?vue&type=script&setup=true&lang=js"

import "./AllSchedules.vue?vue&type=style&index=0&id=f6b0b788&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6b0b788"]])

export default __exports__